<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="principal">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard"> Movimiento Tramite</v-toolbar-title>
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center" v-if="loaded == false">
                        <v-col cols="12" md="7">
                            <v-skeleton-loader
                                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row justify="center" v-else>
                        <v-col cols="12" md="7">
                            <div>
                                <span class="type-label-style">Tipo de Movimiento:</span>
                                <p class="type-text-style">{{ this.tipoTramite.tipomov }}</p>
                            </div>
                            <div class="my-5">
                                <span class="type-label-style">Fecha del movimiento:</span>
                                <v-dialog ref="dialogfh" outlined v-model="modalfh" :return-value.sync="selectedDate"
                                    persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="date-align-center">
                                            <v-text-field class="pt-2" v-model="selectedDate" label="" outlined dense
                                                v-bind="attrs" v-on="on" readonly>
                                            </v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="selectedDate" :min="dateComponentConstraints.fechaMinima"
                                        :max="dateComponentConstraints.fechaMaxima" locale="es" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="secondary" @click="modalfh = false">Cancelar</v-btn>
                                        <v-btn text color="primary" @click="$refs.dialogfh.save(selectedDate)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div v-if="this.tipoTramite.showresp">
                                <span class="type-label-style">Respuesta:</span>
                                <v-radio-group v-model="respuesta" row>
                                    <v-radio label="SI" value="S"></v-radio>
                                    <v-radio label="NO" value="N"></v-radio>
                                </v-radio-group>
                                <span v-if="validarespuesta" class="spanError" style="color: red; font-size: 11px">Campo
                                    requerido</span>
                            </div>
                            <div id="selectType" class="my-1" v-if="Tramites.opcionesTramites.length > 1">
                                <span class="type-label-style">Concepto:</span>
                                <multiselect :disabled="Tramites.opcionesTramites.length === 1"
                                    v-model="Tramites.Tramite"
                                    deselect-label="No se puede remover el valor seleccionado"
                                    selected-label="Seleccionado" select-label="Seleccione un documento"
                                    track-by="ceclave" label="ceconcepto" placeholder="Seleccione una opción"
                                    :options="Tramites.opcionesTramites" :allow-empty="false" :max-height="150">
                                </multiselect>


                                <span v-if="validatramite" class="spanError" style="color: red; font-size: 11px">Campo
                                    requerido</span>
                            </div>
                            <div v-if="showinfPreliminar">
                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span class="type-label-style">Valuación daño ajustador:</span>
                                    <span class="type-label-style" style="font-weight: bold;"> {{ this.svestdanosveh
                                    }}</span>
                                </div>

                                <v-divider class="mt-1"></v-divider>
                                <span class="type-label-style">Indicios:</span>
                                <div v-for="(item, index) in datosIndicios" :key="index">
                                    <v-list-item>
                                        <v-list-item-action class="mr-1">
                                            <v-checkbox :value="item.inclave" v-model="arrayIndicios"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content class="document-chekboxes-style">
                                            {{ item.indescripcion }}
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                                <span v-if="valdatosIndicios" class="error-message-style mb-3">Debe seleccionar al
                                    menos una opción</span>
                            </div>
                            <div v-if="showdatosPrue">
                                <v-divider class="mt-1"></v-divider>
                                <span class="type-label-style">Datos de Prueba:</span>
                                <div v-for="(item, index) in datosPrueba" :key="index">
                                    <v-list-item>
                                        <v-list-item-action class="mr-1">
                                            <v-checkbox :value="item.cdpclave" v-model="valDatoPrueba"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content class="document-chekboxes-style">
                                            {{ item.cdpdescripcion }}
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                                <span v-if="valdatosPruebas" class="error-message-style mb-3">Debe seleccionar al
                                    menos una opción</span>
                                <v-divider class="mt-1"></v-divider>
                                <div v-if="mostrarOpcTec">
                                    <div v-for="(item, i) in opcionTec" :key="i" class="ml-5">
                                        <v-list-item>
                                            <v-list-item-action class="mr-1">
                                                <v-checkbox :value="item.otclave" v-model="valOpcTecnica"></v-checkbox>
                                            </v-list-item-action>
                                            <v-list-item-content class="document-chekboxes-style">
                                                {{ item.otdescripcion }}
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                    <span v-if="valopcionTec" class="error-message-style mb-3">Debe seleccionar al menos
                                        una
                                        opción</span>
                                    <v-divider class="mt-1"></v-divider>
                                </div>
                            </div>
                            <div v-if="showinfPreliminar">
                                <div class="mt-2">
                                    <span class="type-label-style">Mecánica de hechos:</span>
                                    <v-textarea v-on:blur="mecanica = mecanica.trim()" v-model="mecanica" class="mt-1"
                                        :rules="rulestextarea" outlined
                                        :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                </div>
                                <div>
                                    <span class="type-label-style">Opinión técnica sobre la responsabilidad de
                                        conductor:</span>
                                    <v-textarea v-on:blur="optecnica = optecnica.trim()" v-model="optecnica"
                                        class="mt-1" :rules="rulestextarea" outlined
                                        :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                </div>
                                <div>
                                    <span class="type-label-style">Para el caso de homicidio y/o lesiones matriz de
                                        indemnización:</span>
                                    <v-textarea v-on:blur="indemnizacion = indemnizacion.trim()" v-model="indemnizacion"
                                        class="mt-1" :rules="rulestextarea" outlined
                                        :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                </div>
                                <div>
                                    <span class="type-label-style">Antecedentes (Cronología de actividades
                                        iniciales):</span>
                                    <v-textarea v-on:blur="cronologia = cronologia.trim()" v-model="cronologia"
                                        class="mt-1" :rules="rulestextarea" outlined
                                        :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                </div>
                                <div>
                                    <span class="type-label-style">Opinión jurídica del gerente o supervisor:</span>
                                    <v-textarea v-on:blur="opcjur = opcjur.trim()" v-model="opcjur" class="mt-1"
                                        :rules="rulestextarea" outlined
                                        :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                </div>
                            </div>
                            <div v-if="showinfEstrategico">
                                <div>
                                    <span class="type-label-style">Antecedentes:</span>
                                    <v-textarea v-on:blur="antecedentes = antecedentes.trim()" v-model="antecedentes"
                                        class="mt-1" :rules="rulestextarea" outlined
                                        :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                </div>
                                <div>
                                    <span class="type-label-style">Estatus juridico:</span>
                                    <v-textarea v-on:blur="juridico = juridico.trim()" v-model="juridico" class="mt-1"
                                        :rules="rulestextarea" outlined
                                        :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                </div>
                                <div>
                                    <span class="type-label-style">Teoria del caso:</span>
                                    <v-textarea v-on:blur="teoria = teoria.trim()" v-model="teoria" class="mt-1"
                                        :rules="rulestextarea" outlined
                                        :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                            </div>
                            <div v-if="showinfnc">
                                <v-divider class="mt-1"></v-divider>
                                <span class="type-label-style">Estatus jurídico:</span>
                                <v-textarea v-on:blur="estatusjur = estatusjur.trim()" v-model="estatusjur" class="mt-1"
                                    :rules="rulestextarea" outlined
                                    :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                <span class="type-label-style">Motivo por el cual no concluyó a tiempo:</span>
                                <v-textarea v-on:blur="noconcluyo = noconcluyo.trim()" v-model="noconcluyo" class="mt-1"
                                    :rules="rulestextarea" outlined
                                    :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                <span class="type-label-style">Actividades Pendientes:</span>
                                <v-textarea v-on:blur="antecedentespen = antecedentespen.trim()"
                                    v-model="antecedentespen" class="mt-1" :rules="rulestextarea" outlined
                                    :maxlength="$store.state.maxLengthComentarios"></v-textarea>
                                <span class="type-label-style">Fecha tentativa de conclusión y plan de acción:</span>
                                <v-text-field v-on:blur="fectentativa = fectentativa.trim()" v-model="fectentativa"
                                    class="mt-1" :rules="rulestextarea" outlined></v-text-field>
                            </div>
                            <div v-if="showEmail">
                                <div v-if="showdoc">
                                    <div>
                                        <span class="type-label-style"> Documentos: </span>
                                    </div>
                                    <v-row>
                                        <v-col v-for="(item, index) in inputDinamicos" :key="index">
                                            <v-checkbox v-if="item.tipoInput == 'checkbox'"
                                                v-model="dynamicInputVmodels[index].valor">
                                                <template slot="label">
                                                    <span class="document-chekboxes-style">
                                                        {{ item.txtlabel }}
                                                    </span>
                                                </template>
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <div v-if="this.errorDoc == true">
                                        <span class="error-message-style mb-3">Debe seleccionar al menos una
                                            opción</span>
                                    </div>
                                </div>

                                <div>
                                    <span class="type-label-style"> Correos: </span>
                                </div>
                                <v-row class="mt-4">
                                    <div v-for="(item, index) in extraDataItems" :key="index" :class="'mt-2 ' + item.size != null
                                        ? 'col-12 col-md-' + item.size : ''">
                                        <div id="texFieldType" v-if="item.tipoInput == 'textfield'">
                                            <span class="type-label-style">{{ item.txtLabel }}</span>
                                            <v-text-field v-on:blur=" dynamicVModels[index].valor = dynamicVModels[index].valor.trim()
                                                " :rules="dynamicRulesGen(item)"
                                                :type="extraDataItems[index].textType != undefined ? extraDataItems[index].textType : 'text'"
                                                solo v-model="dynamicVModels[index].valor">
                                            </v-text-field>
                                        </div>
                                        <div id="selectType" v-if="item.tipoInput == 'select'">
                                            <span class="type-label-style">{{ item.txtLabel }}</span>
                                            <v-select solo :rules="dynamicRulesGen(item)"
                                                v-model="dynamicVModels[index].valor"
                                                :items="dynamicVModels[index].opciones" item-text="descripcion"
                                                item-value="valor"></v-select>
                                        </div>
                                        <div cols="12" md="7" id="mailTextField"
                                            v-if="item.tipoInput == 'mailTextfield'">
                                            <span class="type-label-style">{{ item.txtLabel }}</span>
                                            <v-autocomplete solo chips clearable deletable-chips
                                                :rules="dynamicRulesGen(item)" :items="dynamicVModels[index].items"
                                                v-model="dynamicVModels[index].valor"
                                                :search-input.sync="dynamicVModels[index].searchIteam"
                                                no-data-text="Introduzca un correo válido"
                                                @change="resetItemsSelector($event, item, index)"
                                                @keyup="addMailValider($event, item, index)"></v-autocomplete>
                                            <v-chip class="ma-2" close color="#536DFE" dark v-for="(chips, chipIndex) in dynamicVModels[index]
                                                .selectedItems" :key="chipIndex"
                                                @click:close="deleteFromList(index, chips)">
                                                {{ chips }}
                                            </v-chip>
                                        </div>
                                        <div id="selectType" v-if="item.tipoInput == 'selectCorreos'">
                                            <div style="height: 22px"></div>
                                            <v-select solo :rules="dynamicRulesGen(item)"
                                                v-model="dynamicVModels[index].valor"
                                                :items="dynamicVModels[index].opciones" item-text="descripcion"
                                                item-value="valorZona" @change="
                                                    newSelectedMails(dynamicVModels[index].valor, index - 1)
                                                    "></v-select>
                                        </div>
                                        <div id="areaType" v-if="item.tipoInput == 'textarea'">
                                            <span class="type-label-style">{{ item.txtLabel }}</span>
                                            <v-textarea v-on:blur="
                                                dynamicVModels[index].valor =
                                                dynamicVModels[index].valor.trim()
                                                " :rules="dynamicRulesGen(item)" v-model="dynamicVModels[index].valor"
                                                class="mt-1" outlined></v-textarea>
                                        </div>
                                        <div id="TODO_other"></div>
                                    </div>
                                </v-row>
                            </div>
                            <div class="mt-2">
                                <v-icon id="publico" class="disable-action" :color="'#4CAF50'" large v-show="tramPublic"
                                    @click="cambiarpubpriv()"
                                    :readonly="cambirPP">mdi-lock-open-variant-outline</v-icon>
                                <v-icon id="privado" class="disable-action" :color="'#F44336'" large
                                    v-show="tramPrivate" @click="cambiarpubpriv()"
                                    :readonly="cambirPP">mdi-lock-outline</v-icon>
                            </div>
                            <div class="mt-4">
                                <span class="type-label-style">Observaciones:</span>
                                <v-textarea style="padding-left: 0px !important;"
                                    v-on:blur="observaciones = observaciones != null ? observaciones.trim() : null"
                                    v-model="observaciones" id="textareaobs" :class="classobs" :rules="rulestextarea"
                                    outlined class="mt-2 textarea" hide-details
                                    :maxlength="$store.state.maxLengthComentarios"
                                    :counter="$store.state.maxLengthComentarios"></v-textarea>
                                <v-row>
                                    <v-col>
                                        <span style="color: red;">{{ obsError }}</span>
                                    </v-col>
                                    <v-col style="display: grid; place-items: end;">
                                        <span class="v-counter">{{ contador }}/{{ $store.state.maxLengthComentarios
                                        }}</span>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                    <v-row justify="center" class="mb-8">
                        <v-btn class="ma-2" color="#536DFE" :disabled="disabledSave" style="color:white"
                            @click="guardarTramite()">Guardar</v-btn>
                        <v-btn class="ma-2" color="default" :disabled="disabledSave" @click="limpiar()">Limpiar</v-btn>
                        <v-btn class="ma-2" color="error" :disabled="disabledSave" @click="cancelar()">Cancelar</v-btn>
                    </v-row>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-else>
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard"> Autorizar Conclusión</v-toolbar-title>
            </v-card-title>
            <v-card-text>
                <v-row justify="center" v-if="loaded == false">
                    <v-col cols="12" md="7">
                        <v-skeleton-loader
                            type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                    </v-col>
                </v-row>
                <div>
                    <v-row justify="center" v-if="loaded == true">
                        <v-col cols="12" md="10">
                            <div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>NA</th>
                                            <th>NO</th>
                                            <th>SI</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(pregunta, index) in preguntas" :key="index">
                                            <td>
                                                <v-radio-group v-model="respcheck[index]" row>
                                                    <v-radio :value="pregunta.claid + ':NA'"
                                                        :name="pregunta.claid.toString()"
                                                        v-if="pregunta.clacheckna == 1"></v-radio>
                                                </v-radio-group>
                                            </td>
                                            <td>
                                                <v-radio-group v-model="respcheck[index]" row>
                                                    <v-radio :value="pregunta.claid + ':N'"
                                                        :name="pregunta.claid.toString()"></v-radio>
                                                </v-radio-group>
                                            </td>
                                            <td align="center">
                                                <v-radio-group v-model="respcheck[index]" row>
                                                    <v-radio :value="pregunta.claid + ':S'"
                                                        :name="pregunta.claid.toString()"
                                                        @click="ValidarMovimiento(pregunta.claid, index)"></v-radio>
                                                </v-radio-group>
                                            </td>
                                            <td>
                                                {{ pregunta.clapregunta }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center" class="mb-8">
                    <v-btn class="ma-2" color="#536DFE" style="color:white" @click="GuardarValidacionAbogado()"
                        :disabled="disabledSaveCk">Siguiente</v-btn>
                    <v-btn class="ma-2" color="error" @click="LimpiarCjeck()"
                        :disabled="disabledSaveCk">Cancelar</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="modalfirma">
            <v-card>
                <v-toolbar color="primary" dark>Autorizar movimientos con respuesta NO APLICA</v-toolbar>
                <v-card-text>
                    <label> Firma electrónica: </label>
                    <br />
                    <v-text-field id="firma" ref="input" v-model="efirma" autocomplete="off" maxlength="17"
                        style="-webkit-text-security: disc;" @focus="Foco()" autofocus solo></v-text-field>
                    <span v-if="msg" id="revfirmaelectronica" style="font-style: italic; color: red">{{ texto }}</span>
                    <br />
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn @click="CerrarModal()">Cerrar</v-btn>
                    <v-btn @click="ValidarFirma()" color="primary" :loading="loading"
                        :disabled="loading">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import ServTramites from "@/services/Tramites/Tramites.service.js";
import reporteExpJur from "@/services/ExpJur/ExpJur.service.js";
import reporteMovimientos from "@/services/Movimientos/Movimientos.service.js";
import reporteGeneral from '@/services/ReporteGeneral/ReporteGeneral.service.js';


export default {
    title() {
        return this.$route.meta.title
    },
    props: ["tokenData"],
    data() {
        return {
            svfhrreporte: null,
            dialogfh: false,
            modalfh: false,
            classobs: "",
            disabledSave: false,
            disabledSaveCk: false,
            validForm: true,
            loaded: false,
            tipoTramite: {
                cetipo: 0,
                showresp: false,
                tipomov: ''
            },
            selectedDate: "",
            dateCollabsable: false,
            dateComponentConstraints: {},
            respuesta: null,
            Tramites: {
                opcionesTramites: [],
                ceclave: 0,
                ceconcepto: null,
                Tramite: null,
                mppconcepto: null,
                mppfijo: 0,
                mppvalor: 0
            },
            obsError: "",
            rulestextarea: [
                (v) => !!v || "Campo requerido",
                (v) => {
                    if (v == null) {
                        return true;
                    } else {
                        if (v.trim().length < 12) {
                            return "Mínimo 12 Carácteres";
                        } else if (v.trim().length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                        } else return true;
                    }
                },
            ],
            observaciones: "",
            tramPublic: true,
            tramPrivate: true,
            colortextArea: "#E5E1E19C",
            validatramite: false,
            validarespuesta: false,
            esid: 0,
            cambirPP: true,
            datosPrueba: [],
            opcionTec: [],
            valDatoPrueba: [],
            valOpcTecnica: [],
            mostrarOpcTec: false,
            documentosTag: false,

            extraDataItems: [],
            inputDinamicos: [],
            dynamicVModels: [],
            dynamicInputVmodels: [],
            noMailsSelected: false,
            tempMails: [],
            showinfEstrategico: false,
            antecedentes: "",
            juridico: "",
            teoria: "",
            showEmail: false,
            valdatosPruebas: false,
            valopcionTec: false,
            errorDoc: false,
            showdoc: false,
            doccheck: [],
            MensajeSeccion1: '',
            MensajeSeccion2: '',
            objetoMensaje: 0,
            principal: true,
            validFormCheck: true,
            loadedCheck: false,
            errorCheckAbog: false,
            validacion: 0,
            valrespNO: false,
            allChecked: [],
            modalfirma: false,
            efirma: '',
            msg: false,
            loading: false,
            texto: '',
            mailSelected: 0,
            showinfnc: false,
            estatusjur: '',
            noconcluyo: '',
            antecedentespen: '',
            fectentativa: '',
            showdatosPrue: false,
            showinfPreliminar: false,
            svestdanosveh: '',
            datosIndicios: [],
            arrayIndicios: [],
            mecanica: '',
            optecnica: '',
            indemnizacion: '',
            cronologia: '',
            opcjur: '',
            valdatosIndicios: false,
            ////////////
            preguntas: [],
            respcheck: [],
            respNo: false,
            respuesta: null,
            reporte: {},
            ruta: null,
            contador: 0,
            asistenciaurl: '',
            puedeGuardar: true,
            user: '',
            tienePermisoAC: false
        }
    },
    async mounted() {
        this.reporte = await MetodosGenerales.obtenerSessionReporte("reporte");
        this.changeReporteMenuOption('Movimiento');
        this.setMenuButtonSelected();
        this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.reporte);
        let valestatus = await MetodosGenerales.getReporteEstatus(this);
        if (valestatus == 2) {
            this.$router.push({ path: this.asistenciaurl + '/MovimientoGeneral' });
        } else {
            this.getDatosGenerales();
        }

        // if(tramite.ceclave === 866){
        //     console.log('este es un 866');
        // }
        // if(this.Tramites.opcionesTramites.length === 1) 
        // this.Tramites.Tramite = this.Tramites.opcionesTramites[0]

    },
    updated() {
        this.VerificarPermisoParaAsistenciaCivil()
    },

    watch: {
        'observaciones'(val) {
            if (val != '') {
                this.obsError = "";
                this.contador = this.observaciones?.length ?? 0
            } else {
                this.contador = 0
            }
        },
        dynamicInputVmodels: {
            deep: true,
            handler(newVal, oldVal) {
                let valores = [];
                newVal.forEach((element) => {
                    if (element.idNombre == "chDocumentos") {
                        if (element.valor == true) {
                            this.errorDoc = false;
                            valores = valores + element.textLabel + "\r\n"
                        }
                    }
                });
                this.dynamicVModels[this.objetoMensaje].valor = this.MensajeSeccion1 + "\r\n" + valores + "\r\n\r\n" + this.MensajeSeccion2;
            }
        },
        'Tramites.Tramite'(val) {
            this.observaciones = "";
            this.showdoc = false;
            this.showinfEstrategico = false;
            this.showEmail = false;
            this.principal = true;
            this.showinfnc = false;
            this.showdatosPrue = false;
            this.showinfPreliminar = false;
            this.svestdanosveh = '';

            if (val != null) {
                this.validatramite = false;
                var privado = document.getElementById("privado");
                var publico = document.getElementById("publico");
                if (val.mppclave == 2 || val.mppclave == 4) {
                    if (val.mppclave == 4) {
                        privado.classList.remove("disable-action");
                        publico.classList.remove("disable-action");
                    } else {
                        privado.classList.remove("active-action");
                        publico.classList.remove("active-action");
                        privado.classList.add("disable-action");
                        publico.classList.add("disable-action");
                    }

                    this.tramPublic = false;
                    this.tramPrivate = true;
                    this.esid = 8;
                    this.classobs = "observaciones-priv"
                } else if (val.mppclave == 1 || val.mppclave == 3) {
                    if (val.mppclave == 3) {
                        privado.classList.remove("disable-action");
                        publico.classList.remove("disable-action");
                    } else {
                        privado.classList.remove("active-action");
                        publico.classList.remove("active-action");
                        privado.classList.add("disable-action");
                        publico.classList.add("disable-action");
                    }
                    this.tramPublic = true;
                    this.tramPrivate = false;
                    this.esid = 7;
                    this.classobs = "observaciones-pub"
                }
                this.ValidacionesMovTramite(val);
            }
        },
        respuesta(val) {
            if (val != null) {
                this.validarespuesta = false;
            }
        },
        'valDatoPrueba'(val) {
            this.valdatosPruebas = false
            if (this.valDatoPrueba.includes(8)) {
                this.mostrarOpcTec = true;
                this.CatalogoOpcionTecnica();
            } else {
                this.mostrarOpcTec = false;
                this.valOpcTecnica = [];
            }
        },
        'arrayIndicios'(val) {
            this.valdatosIndicios = false
        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),

        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },

    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        handlePaste(event) {
            event.preventDefault();
        },
        setMenuButtonSelected() {
            let selectedOption = this.$route.name;
        },
        resetItemsSelector(event, item, listIndex) {
            if (this.dynamicVModels[listIndex].valor != null) {
                this.mailSelected++;
                this.dynamicVModels[listIndex].selectedItems.push(
                    this.dynamicVModels[listIndex].valor
                );
                this.dynamicVModels[listIndex].searchIteam = null;
                this.dynamicVModels[listIndex].items = null;
            }
        },
        async newSelectedMails(value, listIndex) {
            this.mailSelected++;
            let correosResponse = await reporteExpJur.obtenerCorreosPorZona(this, value);
            if (this.tempMails.length > 0) {
                this.dynamicVModels[listIndex].selectedItems = this.dynamicVModels[
                    listIndex
                ].selectedItems.filter((item) => !this.tempMails.includes(item));
            }
            correosResponse.data.forEach((element) => {
                this.tempMails.push(element.correo);
                this.dynamicVModels[listIndex].selectedItems.push(element.correo);
            });
        },
        deleteFromList(index, item) {
            this.dynamicVModels[index].selectedItems = this.dynamicVModels[
                index
            ].selectedItems.filter((element) => element !== item);

            if (this.dynamicVModels[index].selectedItems.length == 0) {
                this.dynamicVModels[index].valor = null;
            }
        },
        Foco() {
            this.msg = false;
        },
        CerrarModal() {
            this.modalfirma = false;
            this.firma = '';
            this.texto = '';
        },
        async ValidarFirma() {
            if (this.efirma.length == 0) {
                this.msg = true;
                this.texto = 'Campo de rquerido';
            }
            else if (this.efirma.length < 8 || this.efirma.length > 16) {
                this.msg = true;
                this.texto = 'El número de caracteres debe ser un mínimo de 8 y menor a 17';
            }
            else {
                this.loading = true;
                let eFirmaValidResponse = await reporteMovimientos.ValidarEFirma(this, this.efirma);
                if (eFirmaValidResponse.length == 1) {
                    this.modalfirma = false;
                    if (this.respNo) {
                        this.$swal({
                            position: "center",
                            icon: "warning",
                            title: "Alerta",
                            html: `No se le permitirá continuar con el movimiento Solicitud de conclusión a ejecutivo, ya que hay alguna pregunta con respuesta NO, sus respuestas deberán tener respuesta SI o NO APLICA para poder continuar.`,
                            confirmButtonText: "Aceptar",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowHtmlTags: true,
                            timer: 4500,
                        }).then(() => {
                            window.location.reload();
                        });
                    } else {
                        await this.guardarValidacionAbogado(0, 1, 1);
                    }
                } else {
                    this.msg = true;
                    this.texto = 'Su firma electrónica es incorrecta';
                }
                this.efirma = '';
                this.loading = false;
            }
        },
        dynamicRulesGen(item) {
            var resultRules = [];
            try {
                if (item.required == "SI" && item.idNombre != "tCorreoPara") {
                    resultRules.push((v) => !!v || "Campo requerido");
                }
                if (item.regex != null) {
                    if (item.idNombre != "tCorreoCopia" && item.idNombre != "tCorreoPara") {
                        resultRules.push(
                            (v) => new RegExp(item.regex).test(v) || "Inserte un valor valido"
                        );
                    } else if (item.idNombre == "tCorreoPara" && this.dynamicVModels[0].selectedItems.length == 0) {
                        resultRules.push("Debe ingresar al menos un correo");
                    }
                }
            } catch (e) {
            }
            return resultRules;
        },
        addMailValider(event, item, listIndex) {
            if (
                RegExp(item.regex).test(this.dynamicVModels[listIndex].searchIteam) ==
                true
            ) {
                this.dynamicVModels[listIndex].items = [
                    {
                        value: this.dynamicVModels[listIndex].searchIteam,
                        text: this.dynamicVModels[listIndex].searchIteam,
                    },
                ];
            }
        },
        async newSelectedMails(value, listIndex) {
            //TODO: append here the mails with the petion of item.servicio
            let correosResponse = await reporteExpJur.obtenerCorreosPorZona(this, value);
            if (this.tempMails.length > 0) {
                this.dynamicVModels[listIndex].selectedItems = this.dynamicVModels[
                    listIndex
                ].selectedItems.filter((item) => !this.tempMails.includes(item));
            }

            correosResponse.data.forEach((element) => {
                this.tempMails.push(element.correo);
                this.dynamicVModels[listIndex].selectedItems.push(element.correo);
            });
        },
        cambiarpubpriv() {
            if (this.esid == 7) {
                this.tramPublic = false
                this.tramPrivate = true
                this.colortextArea = '#F443365C'
                this.esid = 8;
                this.classobs = "observaciones-priv";

            } else {
                this.tramPublic = true
                this.tramPrivate = false
                this.colortextArea = '#4CAF5070'
                this.esid = 7;
                this.classobs = "observaciones-pub";
            }
        },
        async MenuReporte() {
            let formData = new FormData();
            formData.append("nrreporte", this.reporte.nrreporte);
            formData.append("svindice", this.reporte.svindice);
            formData.append("aiclave", this.reporte.aiclave);
            let data = await reporteGeneral.MenuReporte(this, formData);

            if (data[0].nombre == "Juicios Orales") this.ruta = "JuiciosOralesExpJur";
            else if (data[0].nombre == "Civico Civil") this.ruta = "CivicoExpJur";
            else if (data[0].nombre == "AvePrev Consig") this.ruta = "AvePreviaExpJur";
            else if (this.reporte.aiclave == 5) this.ruta = "ProfesionalRCMedico";
            else if (this.reporte.aiclave == 24) this.ruta = "AverPrevRobo";
            else if (this.reporte.aiclave == 23) this.ruta = "AverPrevRLV";

        },
        async getDatosGenerales() {
            //let today = new Date().toJSON().slice(0, 10);
            let res = await MetodosGenerales.obtenerFechaHoraBase();
            let today = res.today;
            this.selectedDate = today;
            this.dateComponentConstraints.fechaMaxima = today;
            this.tipoTramite = MetodosGenerales.getJsonTokenData(this.tokenData);
            let aux = this.tipoTramite.reporte.split('-');

            let formData = new FormData();
            await this.MenuReporte();
            let _urlname = this.ruta;
            let _nrreporte = aux[0];
            let _svindice = aux[1];
            let _aiclave = aux[2];
            let _svfhconclusion = aux[3];

            let reporte = {
                nrreporte: _nrreporte,
                svindice: _svindice,
                aiclave: _aiclave,
                svfhconclusion: _svfhconclusion,
                urlname: _urlname
            };
            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
            await ServTramites.ObtenerCatalogoTramites(this, this.tipoTramite.cetipo)
            let fecha = await reporteGeneral.fechaSvreporte(this, this.reporte);
            this.dateComponentConstraints.fechaMinima = fecha[0].svfhreporte;
            this.loaded = true;
            this.dateCollabsable = true;
            // console.log('Tramites: ', Tramites);
        },

        async limpiar() {
            await this.$refs.form.reset();
            let res = await MetodosGenerales.obtenerFechaHoraBase();
            let today = res.today;
            this.dateComponentConstraints.fechaMaxima = today;
            this.selectedDate = today;
            this.Tramites.Tramite = null;
            this.tramPublic = true;
            this.tramPrivate = true;
            this.cambirPP = true;
            this.classobs = "";
            this.dynamicVModels = [];
            this.validatramite = false;
            this.errorDoc = false;
            this.obsError = "";
            this.validarespuesta = false;
        },
        LimpiarCjeck() {
            window.location.reload();
        },
        async cancelar() {
            this.$router.replace({ path: this.asistenciaurl + '/MovimientoGeneral' });
        },
        async guardarTramite() {
            this.validacionCampos();
            if (this.validarespuesta == false && this.validatramite == false && this.$refs.form.validate()) {
                let val = false;
                if (this.respuesta == 'S') {
                    this.disabledSave = true;
                    val = await ServTramites.ValidarMovimientosTramites(this.Tramites.Tramite.ceclave);
                }
                if (val == false) {
                    this.disabledSave = true;
                    this.$swal({
                        position: "center",
                        title: "Cargando...",
                        html: "Espere un momento por favor",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirm: false,
                    });
                    this.$swal.showLoading();
                    let movimientoBody = {};
                    movimientoBody.ceclave = this.Tramites.Tramite.ceclave;
                    movimientoBody.observaciones = this.observaciones;
                    movimientoBody.respuesta = this.respuesta;
                    movimientoBody.fecha = this.selectedDate;
                    movimientoBody.esid = this.esid
                    if (this.Tramites.Tramite.ceclave === 866) movimientoBody.procesoCivil = true

                    if ([793, 794, 795, 796, 802, 803, 804].includes(this.Tramites.Tramite.ceclave)) {
                        this.dynamicVModels.forEach((element) => {
                            if (element.selectedItems != undefined && element.selectedItems != null) {
                                movimientoBody[element.textLabel] = element.selectedItems.toString();
                            }
                            if (element.valor != undefined || element.valor != null) {
                                if ((element.textLabel == "tCorreoCopia" || element.textLabel == "tCorreoPara") && element.selectedItems.length > 0) {
                                    movimientoBody[element.textLabel] = element.selectedItems.join(";");
                                } else {
                                    movimientoBody[element.textLabel] = element.valor;

                                }
                            }
                        });
                        if (this.Tramites.Tramite.ceclave == 794) {
                            movimientoBody.valDatoPrueba = this.valDatoPrueba.join();
                            movimientoBody.opiontecnica = this.valOpcTecnica.join();
                            movimientoBody.dato1 = this.antecedentes;
                            movimientoBody.dato2 = this.juridico;
                            movimientoBody.dato3 = this.teoria;
                        } else if (this.Tramites.Tramite.ceclave == 795) {
                            movimientoBody.valDatoPrueba = this.valDatoPrueba.join();
                            movimientoBody.opiontecnica = this.valOpcTecnica.join();
                            movimientoBody.dato1 = this.estatusjur;
                            movimientoBody.dato2 = this.noconcluyo;
                            movimientoBody.dato3 = this.antecedentespen;
                            movimientoBody.dato4 = this.fectentativa;
                        } else if (this.Tramites.Tramite.ceclave == 793) {
                            movimientoBody.valDatoPrueba = this.valDatoPrueba.join();
                            movimientoBody.opiontecnica = this.valOpcTecnica.join();
                            movimientoBody.dato1 = this.cronologia;
                            movimientoBody.dato2 = this.optecnica;
                            movimientoBody.dato3 = this.indemnizacion;
                            movimientoBody.dato4 = this.opcjur;
                            movimientoBody.dato5 = this.mecanica;
                            movimientoBody.indicios = this.arrayIndicios.join();
                        } else if (this.Tramites.Tramite.ceclave == 796) {
                            let tempDocObject = [];
                            this.dynamicInputVmodels.forEach((element) => {
                                if (element.idNombre == "chDocumentos") {
                                    if (element.valor == true) {
                                        tempDocObject.push(element.docValor);
                                        this.doccheck.push(element.docValor);
                                    }
                                }
                            });
                            movimientoBody.documentos = tempDocObject.toString();
                        }
                    }
                    this.errorDoc = false;
                    let movimientoResponse = await ServTramites.GuardarTramite(this, movimientoBody);

                    if (movimientoResponse == true) {
                        if (this.Tramites.Tramite.ceclave == 535) {
                            await this.guardarValidacionAbogado(1, 2, 0);
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito!",
                                html: "Se agrego de manera éxitosa el tramite",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 5500,
                            }).then(() => {
                                setTimeout(() => {
                                }, 5000);
                                this.$router.push({ path: this.asistenciaurl + '/MovimientoGeneral' });
                            });
                        }


                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: "Éxito!",
                            html: "Se agregó de manera exitosa el trámite",
                            confirmButtonText: "Aceptar",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 4500,
                        }).then(() => {
                            this.$router.push({ path: this.asistenciaurl + '/MovimientoGeneral' });
                        });
                    } else {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Error al guardar el trámite.",
                            html: "Hubo un error intentelo de nuevo",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    }
                } else {
                    this.$swal({
                        position: "center",
                        icon: "warning",
                        title: "Alerta",
                        html: "Debe ingresar este Movimiento con respuesta Sí en el Movimiento Principal (Check List).",
                        showConfirmButton: true,
                        confirmButtonColor: '#536DFE',
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false,
                    });
                    this.disabledSave = false
                }
            }
        },
        validacionCampos() {
            this.$refs.form.validate()
            if (this.Tramites.Tramite == null) { this.validatramite = true; }
            if (this.respuesta == null && this.tipoTramite.showresp == true) { this.validarespuesta = true; }
            if (this.showinfEstrategico == true) {
                if (this.valDatoPrueba.length == 0) { this.valdatosPruebas = true }
                if (this.mostrarOpcTec == true && this.valOpcTecnica.length == 0) { this.valopcionTec = true }
            }
            if (this.showdoc == true) {
                let tempDocObject = [];
                this.dynamicInputVmodels.forEach((element) => {
                    if (element.idNombre == "chDocumentos") {
                        if (element.valor == true) {
                            tempDocObject.push(element.docValor);
                            this.doccheck.push(element.docValor);
                        }
                    }
                });
                if (tempDocObject.length == 0) { this.errorDoc = true; }
            }
            if (this.tipoTramite.showresp == false) {
                this.respuesta = "S";
            } if (this.showinfPreliminar == true) {
                if (this.arrayIndicios.length == 0) { this.valdatosIndicios = true; }
                if (this.valDatoPrueba.length == 0) { this.valdatosPruebas = true }
                if (this.mostrarOpcTec == true && this.valOpcTecnica.length == 0) { this.valopcionTec = true }
            }
            if (this.observaciones == null || this.observaciones == '') {
                this.obsError = "Campo requerido";
            }
            else if (this.observaciones != '') {
                if (this.observaciones.trim().length < 12) {
                    this.obsError = "Mínimo 12 Carácteres";
                }
                else if (this.observaciones.trim().length > this.$store.state.maxLengthComentarios) {
                    this.obsError = "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                }
            }
        },
        async ValidacionesMovTramite(tramite) {
            if (tramite.ceclave == 794) {
                this.showdoc = false;
                this.showdatosPrue = true;
                this.showinfEstrategico = true;
                await ServTramites.CatalogoDatosPrueba(this);
                let movimientoResponse = await ServTramites.ObtenerDatosPruebaReporteInforme(this);
                if (movimientoResponse.length > 0) {
                    let dprseleccionArray = movimientoResponse[0].dprseleccion.split(',').map(Number);
                    this.valDatoPrueba = dprseleccionArray;
                    let dpropiontecnicaArray = typeof movimientoResponse[0].dpropiontecnica != 'object' ? movimientoResponse[0].dpropiontecnica.split(',').map(Number) : [];
                    this.valOpcTecnica = dpropiontecnicaArray;
                }
                this.seccionCorreo();
            } else if (tramite.ceclave == 795) {
                this.showdoc = false;
                this.showinfnc = true;
                this.seccionCorreo();
            } else if (tramite.ceclave == 796) {
                this.documentosTag = true;
                this.showdoc = true;
                await this.seccionCorreo();
                this.objetoMensaje = this.dynamicVModels.findIndex(objeto => objeto.textLabel === "txtMensaje");
                const indiceSeparador = this.dynamicVModels[this.objetoMensaje].valor.indexOf("Datos");
                this.MensajeSeccion1 = this.dynamicVModels[this.objetoMensaje].valor.substring(0, indiceSeparador);
                this.MensajeSeccion2 = this.dynamicVModels[this.objetoMensaje].valor.substring(indiceSeparador);
            } else if (tramite.ceclave == 535) {

                this.disabledSave = true;
                let resp = await ServTramites.ValidarPrecierre(this)
                if (resp == 1) {
                    this.loadedCheck = true;
                    this.disabledSaveCk = true;
                    await this.ObtenerPreguntas();
                } else {
                    this.$swal({
                        position: "center",
                        icon: "warning",
                        title: "Alerta",
                        text: "No se puede solicitar la conclusión a ejecutivo, porque aún no se ha realizado el Pre cierre por parte de líderes.",
                        confirmButtonText: "Aceptar",
                        showConfirmButton: true,
                        confirmButtonColor: '#536DFE',
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false,
                    })
                    this.disabledSave = false;
                    this.Tramites.Tramite = null;
                    this.tramPublic = true;
                    this.tramPrivate = true;
                    this.cambirPP = true;
                    this.classobs = "";
                }
            } else if (tramite.ceclave == 802 || tramite.ceclave == 803 || tramite.ceclave == 804) {
                this.ValidarCarta(tramite.ceclave);
            }
            else if (tramite.ceclave == 847) {
                let validar = await ServTramites.ValidarMovimientoTramite(this, 535);
                if (validar[0].success == 'true') {

                }
                else if (validar[0].success == 'false') {
                    this.$swal({
                        position: "center",
                        icon: "info",
                        //title: "Alerta",
                        html: validar[0].mensaje,
                        confirmButtonText: "Aceptar",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowHtmlTags: true,
                    }).then(() => {
                        //window.location.reload();
                    });
                    this.disabledSave = false;
                    this.Tramites.Tramite = null;
                    this.tramPublic = true;
                    this.tramPrivate = true;
                    this.cambirPP = true;
                    this.classobs = "";
                }
                else {
                    this.$swal({
                        position: "center",
                        icon: "warning",
                        title: "Alerta",
                        html: validar[0].mensaje,
                        confirmButtonText: "Aceptar",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowHtmlTags: true,
                    }).then(() => {
                    });
                    this.disabledSave = false;
                    this.Tramites.Tramite = null;
                    this.tramPublic = true;
                    this.tramPrivate = true;
                    this.cambirPP = true;
                    this.classobs = "";
                }
            }
        },
        async CatalogoOpcionTecnica() {
            await ServTramites.CatalogoOpcionTecnica(this, 8);
        },
        async seccionCorreo() {
            let especificosResponse = await reporteExpJur.ObtenerEspecificosMovimiento(this.reporte, this.Tramites.Tramite.ceclave, 1);
            this.showEmail = true;
            this.inputDinamicos = especificosResponse.inputsDinamicos;
            if (this.inputDinamicos != undefined) {
                this.inputDinamicos.forEach((element) => {
                    let body = {
                        textLabel: element.txtlabel,
                        idNombre: element.idNombre,
                        docValor: element.valor,
                    };
                    if (element.tipoInput.toString().toLowerCase() == "checkbox") {
                        body.valor = false;
                    }
                    this.dynamicInputVmodels.push(body);
                });
            }

            this.extraDataItems = especificosResponse.inputs;
            this.extraDataItems.forEach((element) => {
                let body = {
                    textLabel: element.idNombre,
                    valor: null,
                };
                if (element.tipoInput.toString().toLowerCase() == "mailtextfield") {
                    body.searchIteam = "";
                    body.items = [];
                    body.selectedItems = [];
                }
                if (element.textarea != "") {
                    body.valor = element.valor;
                }
                if (
                    element.tipoInput.toString().toLowerCase() == "select" ||
                    element.tipoInput.toString().toLowerCase() == "selectcorreos"
                ) {
                    body.opciones = element.opciones;
                }

                this.dynamicVModels.push(body);
            });

        },
        async ObtenerPreguntas() {
            this.principal = false;
            this.loaded = false;
            this.preguntas = await ServTramites.CheckListPreguntasAbogado(this);
            if (this.preguntas.length > 0) {
                this.loaded = true;
                this.loadedCheck = false
                this.disabledSaveCk = false;
            } else {
                this.loaded = true;
                this.principal = true;
                this.disabledSave = false;
            }
        },
        async ValidarMovimiento(claid, index) {
            let response = await ServTramites.CheckListAbogadoValMovimientos(this, claid);
            if (response != null) {
                this.$set(this.respcheck, index, null);
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: "Alerta",
                    html: `${response}`,
                    confirmButtonText: "Aceptar",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowHtmlTags: true,
                }).then(() => {
                });
            }
        },
        checkAllSelected() {
            if (this.respcheck.length != 0) {
                if (this.respcheck.length == this.preguntas.length) {
                    for (const respuesta of this.respcheck) {
                        if (!respuesta) {
                            return false; // Si alguna respuesta es falsa (null o undefined), no todos están seleccionados
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        handleRadioClick(event) {
            const target = event.target;
            // Verificar si el elemento clicado es un radio button
            if (target.type === "radio") {
                const questionId = target.getAttribute("name");
                const value = target.value;
                this.validarPregunta(questionId, value);
                this.errorCheckAbog = false;
            }
        },
        async GuardarValidacionAbogado() {
            this.disabledSaveCk = true;
            if (this.checkAllSelected()) {
                this.respNo = this.respcheck.some(registro => registro.includes('N') && !registro.includes('NA'));
                const preguntasConNA = this.respcheck.filter(registro => registro.includes('NA')).map(registro => parseInt(registro.replace('NA', '')));
                this.respuesta = this.respNo == true ? 'N' : null;
                if (preguntasConNA.length > 0) {
                    let response = await ServTramites.ValidacionCLAbogadoNA(this, preguntasConNA.join(', '));
                    this.$swal({
                        position: "center",
                        icon: "warning",
                        title: "Alerta",
                        html: `${response}`,
                        showCancelButton: true,
                        allowOutsideClick: false,
                        confirmButtonColor: '#536DFE',
                        cancelButtonColor: '#FF5C93',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar',
                        allowHtmlTags: true,
                    }).then(async (result) => {
                        if (result.value) {
                            this.modalfirma = true;
                        }
                    })
                } else {
                    if (this.respNo) {
                        this.$swal({
                            position: "center",
                            icon: "warning",
                            title: "Alerta",
                            html: `No se le permitirá continuar con el movimiento Solicitud de conclusión a ejecutivo, ya que hay alguna pregunta con respuesta NO, sus respuestas deberán tener respuesta SI o NO APLICA para poder continuar.`,
                            confirmButtonText: "Aceptar",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowHtmlTags: true,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload();
                            }
                        });
                    } else {
                        await this.guardarValidacionAbogado(0, 1, 0);
                    }
                }
            } else {
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: "Alerta",
                    text: "Debes seleccionar una respuesta para cada pregunta antes de guardar.",
                    confirmButtonText: "Aceptar",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            }
            this.disabledSaveCk = false;
        },
        checkAllSelected() {
            if (this.respcheck.length != 0) {
                if (this.respcheck.length == this.preguntas.length) {
                    for (const respuesta of this.respcheck) {
                        if (!respuesta) {
                            return false; // Si alguna respuesta es falsa (null o undefined), no todos están seleccionados
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        async guardarValidacionAbogado(estatus, tipo, firma) {
            let respuesta = await ServTramites.GuardarRespuestasAbogado(this, JSON.stringify(this.respcheck), estatus, tipo, firma)
            if (respuesta != false) {
                this.principal = true;
                this.disabledSave = false;
            } else {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Error al guardar las respuestas",
                    html: "Hubo un error intentelo de nuevo",
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    timer: 5000,
                });
            }
        },
        async ValidarCarta(ceclave) {
            let respuesta = await ServTramites.validarcarta(this, ceclave);
            if (respuesta != null) {
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: "Alerta",
                    html: `No se puede realizar el movimiento debido a que: <br> <ul class='lista'>${respuesta} </ul>`,
                    confirmButtonText: "Aceptar",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowHtmlTags: true,

                }).then((result) => {
                    if (result.isConfirmed) {
                        this.limpiar()
                    }
                });
            } else {
                this.seccionCorreo();
            }
        },
        VerificarPermisoParaAsistenciaCivil() {
            if (!this.Tramites.Tramite && this.Tramites.opcionesTramites.length === 1) {
                this.Tramites.Tramite = this.Tramites.opcionesTramites[0]
            }
            // if(this.seRevisoPermisoAC !this.tienePermisoAC && this.Tramites.Tramite.ceclave === 866){
            if (!this.tienePermisoAC && this.Tramites.Tramite && this.Tramites.Tramite.ceclave === 866) {
                this.user = MetodosGenerales.ObtenerUserName()
                reporteExpJur.ObtenerOpcionesTramites(this.reporte, this.user).then((response) => {
                    let result = response.filter((opc) => opc.ttrid === 19)
                    if (result.length === 0) {
                        this.$router.replace({ path: this.asistenciaurl + '/MovimientoGeneral' }).catch(() => { });
                    }
                    this.tienePermisoAC = true
                    this.permisoACRevisado = true
                })
            }
        }
    }
}


</script>
<style>
.addMovimientoClassList .vs-collapse-item--header {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
    background-color: #e0e0e0 !important;
}

.addMovimientoClassList .con-content--item {
    padding: 0px !important;
}

.observaciones-priv {
    background-image: url("https://www.ausa.com.mx/img/Prusia/privado.png");
    background-repeat: repeat;
}

.observaciones-pub {
    background-image: url("https://www.ausa.com.mx/img/Prusia/publico.png");
    background-repeat: repeat;
}

ul.lista {
    /* list-style-type: square; */
    font-weight: 400;
    margin-left: 2em;
    text-align: left;
}

ul.lista li {
    list-style-type: square;
    /* Agrega la lista con íconos cuadrados */
}
</style>
<style scoped>
.textarea {
    resize: none !important;
}

.type-label-style {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 14px;
}

.type-text-style {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 1.3em;
}

.collapsable-container {
    background-color: white;
    height: 100% !important;
}

.date-card-title-text {
    margin-top: 1px !important;
    margin-bottom: 1px !important;
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: rgb(59, 59, 59);
}

.disable-action {
    pointer-events: none;
}

.active-action {
    pointer-events: pointer;
}

.error-message-style {
    font-family: "Roboto", sans-serif;
    color: red;
    font-weight: 400;
    font-size: 12px;
}
</style>